<template>
   <div @contextmenu.stop.prevent="onContextmenu">
      <div id="timeline-chart"></div>
      <div v-if="contextMenuWorkLogIndex != null"
           @mouseleave="contextMenuWorkLogIndex = null"
           style="position: absolute" :style="contextMenuPosition">
        <div class="ui vertical menu" style="width: 250px;">
          <a class="teal item" @click="emitSplitEvent">
            Arbeitszeit in der Mitte teilen
          </a>
        </div>
      </div>
   </div>
</template>

<script>
    var Highcharts = require('highcharts');
    require('highcharts/modules/xrange')(Highcharts);
    require('highcharts/modules/draggable-points')(Highcharts);
    var moment = require('moment');

    export default {
        name: 'TimeLineChart',
        props: ['workLogs', 'startTime', 'topicsMap'],
        data: function () {
            return {
                from: moment().startOf('day').set('hour', 7).valueOf(),
                to: moment().startOf('day').set('hour', 19).valueOf(),
                redrawInterval: setInterval(this.drawChart, 30 * 1000),
                chart: null,

                hoveringWorkLogIndex: null,
                contextMenuPosition: null,
                contextMenuWorkLogIndex: null
            }
        },
        computed: {
            wrongTimeRanges: function() {
                let ranges = [];

                if(this.workLogs) {
                    // clone array
                    let logs = [];
                    for (let log of this.workLogs) {
                        logs.push(log);
                    }

                    logs.sort((a, b) => {
                        return a.from - b.from;
                    });

                    let nextFrom = this.startTime;
                    for (let log of logs) {
                        if(log.from > nextFrom) {
                            ranges.push({
                                color: '#fffce5',
                                from: nextFrom,
                                to: log.from
                            });
                        }
                        if(log.from < this.startTime) {
                            ranges.push({
                                color: '#fffce5',
                                from: log.from,
                                to: this.startTime
                            });
                        }
                        nextFrom = Math.max(nextFrom, log.to);
                    }

                    for (let i = 0; i < logs.length; i++) {
                      for (let j = i + 1; j < logs.length; j++) {
                         let logi = logs[i];
                         let logj = logs[j];
                         if (!( logi.to <= logj.from || logi.from >= logj.to )) {
                             ranges.push({
                                 color: '#ffe8e4',
                                 from: Math.max(logi.from, logj.from),
                                 to: Math.min(logi.to, logj.to)
                             });
                         }
                      }
                    }
                }
                return ranges;
            }
        },
        watch: {
            workLogs: {
                deep: true,
                handler: function () {
                    this.drawChart();
                }
            },
            startTime: {
                immediate: true,
                handler: function () {
                    this.from = moment(this.startTime).subtract(30, 'm').valueOf();
                    this.$nextTick(() => {
                        this.drawChart();
                    });
                }
            }
        },
        mounted: function () {
            this.drawChart();
        },
        beforeDestroy: function() {
            clearInterval(this.redrawInterval);
        },
        methods: {
            onContextmenu: function(event) {
              if(this.hoveringWorkLogIndex != null) {
                this.contextMenuWorkLogIndex = this.hoveringWorkLogIndex
                this.contextMenuPosition = {
                  left: event.pageX - 20 + 'px',
                  top: event.pageY - 15 + 'px',
                }
              }
            },
            emitSplitEvent: function() {
              this.$emit('splitWorkLog', this.contextMenuWorkLogIndex)
              this.contextMenuWorkLogIndex = null
            },
            drawChart: function () {
                let vm = this;

                vm.chart = null;

                let data = [];
                let colors = [];
                let topics = Object.values(this.topicsMap).sort((a,b) => { return a.index > b.index; }).map(topic => { colors.push(topic.color); return topic.name; });
                let lastTo = moment(this.startTime);

                if (vm.workLogs != null) {
                    for (let i = 0; i < vm.workLogs.length; i++) {
                        let log = vm.workLogs[i];

                        if (log.topic == null) {
                            log.topic = '';
                        }

                        let index = topics.findIndex((topic) => {
                            return topic == log.topic;
                        });

                        let durationStrings = [];
                        let duration = moment.duration(log.to - log.from);

                        if (duration.hours() > 0) {
                            durationStrings.push(duration.hours() + "h");
                        }
                        if (duration.minutes() > 0) {
                            durationStrings.push(duration.minutes() + "m");
                        }

                        data.push({
                            id: i,
                            x: log.from,
                            x2: log.to,
                            name: durationStrings.join(" "),
                            y: index
                        });

                        let momentLogTo = moment(log.to);
                        if(lastTo.isBefore(momentLogTo) && lastTo.isSame(momentLogTo, 'day')) {
                            lastTo = momentLogTo;
                        }
                    }
                }

                vm.to = (!moment().isSame(vm.from, 'day') ? lastTo : moment()).add(1, 'h').valueOf();

                vm.chart = Highcharts.chart('timeline-chart', {
                    chart: {
                        animation: true, // NOT init animation
                        type: 'xrange',
                        events: {
                            click: function(event) {
                                vm.$emit('click',
                                    topics[Math.floor(event.yAxis[0].value + 0.5)],
                                    moment(event.xAxis[0].value).startOf('minute').valueOf()
                                );
                            }
                        }
                    },

                    colors: colors,

                    time: {
                        useUTC: false
                    },

                    title: {
                        text: ''
                    },

                    tooltip: {
                        enabled: true,
                        headerFormat: '<b>{point.yCategory}</b><br>',
                        outside: true,
                        pointFormatter: function() {
                            return moment(this.x).format("HH:mm") + " - " + moment(this.x2).format("HH:mm");
                        }
                    },

                    legend: {
                        enabled: false
                    },

                    plotOptions: {
                        series: {
                            animation: false, // ONLY init animation
                            minPointLength: 5, // Always show points, even when resized down
                            dataLabels: {
                                enabled: true,
                                format: '{point.name}'
                            },
                            dragDrop: {
                                draggableX: true,
                                draggableY: true,
                                dragPrecisionX: 1000 * 60 * 5, // 5min
                                dragMinX: vm.from,
                                dragMaxX: vm.to,
                                liveRedraw: true,
                                dragHandle: {
                                    lineWidth: 2,
                                }
                            },
                            point: {
                                events: {
                                    drop: function () {
                                        vm.$emit('drag', this.id, {from: this.x, to: this.x2, topic: this.yCategory});
                                    },
                                    mouseOver: function (e) {
                                      vm.hoveringWorkLogIndex = e.target.id
                                    },
                                    mouseOut: function () {
                                      vm.hoveringWorkLogIndex = null
                                    }
                                }
                            }
                        }
                    },

                    xAxis: {
                        type: 'datetime',
                        tickInterval: 30 * 60 * 1000, // every 30 min
                        min: vm.from,
                        max: vm.to,
                        plotLines: [{
                            color: 'red',
                            width: 1,
                            value: moment().valueOf(),
                            zIndex: 10,
                        },{
                            color: '#97e3a4',
                            width: 1,
                            value: vm.startTime,
                            zIndex: 9,
                        }],
                        plotBands: vm.wrongTimeRanges
                    },

                    yAxis: {
                        title: '',
                        min: 0,
                        reversed: true,
                        max: topics.length - 1,
                        type: "category",
                        categories: topics,
                        labels: {
                           formatter: function() {
                               return this.value.length > 20 ? this.value.substr(0, 20) + "..." : this.value;
                           }
                        }
                    },

                    series: [{
                        cursor: 'move',
                        colorByPoint: true,
                        data: data
                    }]
                });
            }
        }
    }
</script>

<style scoped>
   #timeline-chart {
      height: 300px;
   }

   .center {
      text-align: center;
   }
</style>
